import styled from 'styled-components'
import { Icon } from '@amzn/storm-ui'

export const LegendsContainer = styled.div`
  display: flex;
  flex-basis: 0;
  flex-grow: 1;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: ${({ theme }) => theme.spacing.large};
`
export const ClaimedByPartnerIcon = styled(Icon).attrs({
  type: 'circle',
})`
  color: ${({ theme }) => theme.palette.blue[700]};
`

export const LegendContainer = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.small};
`

export const LegendIconContainer = styled.div`
  margin-inline-end: ${({ theme }) => theme.spacing.mini};
`
